<template>
  <div :id="id" class="card">
    <header class="card-header">
      <section class="b-tooltips">
        <b-tooltip class="card-header-title is-light" position="is-bottom" multilined>
          <b-icon icon="info-circle" type="is-primary is-small" class="mr-1" />
          {{ title }}
          <template #content>
            <div v-html="tooltip" />
          </template>
        </b-tooltip>
      </section>
      <span v-if="data.total > 0 && data.data.length !== data.total" class="card-header-icon">
        <span class="tag is-primary is-light">{{ data.data.length }} de {{ data.total }}</span>
      </span>
      <span v-if="data.total > 0 && data.data.length === data.total" class="card-header-icon">
        <span class="tag is-primary is-light">Total: {{ data.total }}</span>
      </span>
    </header>
    <div class="card-content">
      <div class="content">
        <EvaluationItem
          v-for="item in data.data"
          :key="item._id"
          :evaluation="item" />
        <div v-if="data.total > 1 && data.data.length < data.total" class="buttons">
          <b-button
            v-if="data.total > 1 && data.data.length < data.total"
            type="is-primary is-light"
            size="is-small"
            expanded
            rounded
            @click="moreView()">
            Ver más
            <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false" />
          </b-button>
        </div>
        <div v-if="data.total === 0" class="has-text-centered">
          <p>No hay evaluaciones</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import EvaluationItem from '@/ui/components/internal/evaluations/EvaluationItem.vue';

export default {
  name: 'EvaluationColumn',
  components: { EvaluationItem },
  props: {
    title: {
      type: String
    },
    tooltip: {
      type: String
    },
    type: {
      type: String
    },
    data: {
      type: Object,
      default: () => ({ data: [], total: 0 })
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    async moreView() {
      this.$emit('more-view', this.type);
    }
  }

};
</script>
<style scoped>
.card-header {
  box-shadow: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-header-title, h2 {
  color: var(--primary);
}

.card {
  background-color: #cbf9f9;
}

.card-header-title {
  padding: 5px 10px;
  font-weight: 300;
  font-size: 16px;
}

.card-content {
  box-shadow: 0px -2px 15px rgba(100, 100, 100, 0.1);
  background-color: #F2F2F2;
  padding: 10px;
}

.card, .card-content {
  border-radius: 10px;
}

.card {
  box-shadow: none;
}

.button.is-primary.is-light {
  color: var(--primary) !important;
  background-color: #cbf9f9;
}
</style>
<style>
.loading-overlay .loading-icon:after {
  width: 2em;
  height: 2em;
  top: calc(50% - 1em);
}

.loading-overlay .loading-background {
  border-radius: 10px;
}
</style>
